module.exports = __webpack_public_path__ + "img/handle_seat.prt.f8502856.jpg";